module.exports = __webpack_public_path__ + "img/dpdni.d3d6c346.png";